<template>
    <!--页面主体-->
    <div class="g-container">
        <div class="m-container m-width" style="width: 1170px;">
            <!--面包屑-->
            <!--图片banner -->
            <div class="" style="height: 320px;margin-top:20px;">
                <el-carousel height="300px" arrow="never" >
                    <el-carousel-item v-for="item,index in banners" :key="index">
                        <img class="small"  :src="item.PicUrl" alt="">
                    </el-carousel-item>
                </el-carousel>
                <div class="search">
                    <input type="text" placeholder="请输入关键词，查找您想要的产品" v-model="search_input">
                    <div class="soudiv" @click="search"><label class="sousuo"></label></div>
                    <div class="maTop13 paLeft30"><span>热门关键词：环保卷材</span></div>
                </div>
            </div>
            <!--主体 菜单  @mouseenter="onMousteIn(index)" @mouseleave="onMousteOut(index)"-->
            <div class=" font16 dipFx" style="margin-bottom: 125px;width: 1170px;position: relative;top: -15px;">
                <el-col :span="12" style="background:#fff;">
                <div class="paLeft15 paTop12 paBot11 ">分类明细</div>
                    <el-menu class="el-menu-vertical-demo"  background-color="#fff" text-color="#333333" active-text-color="#333333">
                        <div class="typeHover" v-for="(item,index) in types" :key="index"  @click="handleSelect(item,index)">
                            <el-menu-item :class="index == curnum ? 'actives':'bai'" >
                                <i :style="{backgroundImage:'url(' + item.Icon + ')'}" class="imgSize" :class="curnum == index ? 'menuImga':'b'"></i>
                                <span slot="title" class="font15 maIeft8 font_22 hoverSize">{{item.Name}}</span>
                            </el-menu-item>
                        </div>
                       
                    </el-menu>
                </el-col>
                <!--主体-->
                <div class="zhuti">
                    <div class="tabs" id="searchBar" :class="searchBarFixed == true ? 'isFixed' :''"  >
                        <div class="tabsW">
                            <div style="line-height: 48px;padding: 0 40px 0 27px;color:#A5A5A5;background:rgba(240,240,240,1);">我想看：</div>
                            <div class="tabClass" @click="tablist('',indexs)" :class="{'ontabName':tabIndex == indexs}">全部</div>
                            <div v-for="(item,index) in infotype" :key="index" v-if="item.TypeId == TypeIds"
                             @click="tablist(item,index)" class="tabClass" :class="{'ontabName':tabIndex == index}">{{item.Name}}</div>
                        </div>
                    </div>
                    <div >
                    <!--v-if="curnum !=0 || curnum !=''"-->
                        <div v-if="curnum !=0 || curnum !=''">
                            <div class="shop_good" v-for="txt,index in StoreSolution"  v-if="txt.StoreInfoTypeId.indexOf(keyId) >= 0 && tabIndex != -1" >
                                <div class="shopDiv">
                                    <div class="shop" @click="goto(txt.solution.Id)">
                                        <img :src="txt.solution.PicPaths.split(',')[0]" alt="" class="shopimg">
                                    </div>
                                    <div class="baffffff">
                                        <div class="shopName">{{txt.solution.Name}}</div>
                                        <div class="goodsBtn">
                                            <span class="detailBtn"  @click="goto(txt.solution.Id)">查看详情</span>
                                            <span class="detailAsk" @click="outer()">立即咨询</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="shopDeil" :style="txt.material.length<=3 ? 'display:flex;':''">
                                    <div class="shoplist" v-for="item,matIndex in txt.material"  :key="matIndex">
                                        <div class="shopSingle" @click="goto(item.Id)">
                                            <div class="shopD">
                                                <img :src="item.PicPaths.split(',')[0]" alt="" class="shopimg">
                                            </div>
                                            <div class="shopDName">{{item.Name}}</div>
                                            <div class="money">¥ {{item.Price}}</div>
                                        </div>
                                        <div class="heimg" :id="'parent'+(matIndex%3)" 
                                        ></div>
                                    </div>
                                    
                                </div>
                                <!--咨询-预约弹窗-->
                            <el-dialog title="立即免费预约厂家" :visible.sync="outerVisible">

                                <div class="open_input">
                                    <input v-model="phone" @change="tel" type="text" placeholder="请输入您的手机号，厂家会尽快联系到您" :id="oInputId ? 'redInput':'oInput'">
                                    <span v-if="oInputId" class="tishi">请输入正确的手机号</span>
                                </div>
                                <el-dialog width="30%" title="成功预约，等待联系" :visible.sync="innerVisible" append-to-body >
                                    <div class="cg_img">
                                        <i class="cg"></i>
                                    </div>
                                    <div class="changjia">厂家已接收到您的预约信息，稍后就会拨打您电话，请保持电话畅通!</div>
                                </el-dialog>
                                <div slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="open(txt.solution.Id)">立即预约</el-button>
                                </div>
                            </el-dialog>
                            </div>
                            
                            <div style="background: #fff;display: inline-block;margin-top: 20px;width: 950px;" >
                                <div style="padding: 20px;font-size:18px;font-weight:bold;">其他</div>
                                <div class="maTop">
                                    <div class="mall-goods-item" v-for="tet in StoreOther" v-if="tet.onShow" @click="goto(tet.Id)">
                                        <div class="goods-pic">
                                            <img :src="tet.PicPaths.split(',')[0]"  alt="" />
                                        </div>
                                        <div class="goods-info">
                                            <div class="goods-money"><span>零售价</span>¥ {{tet.Price}}</div>
                                            <div class="goods-txt">{{tet.Name}}</div>
                                            <div class="goods-handle">
                                                <div class="goods-buy-btn">查看详情&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <!--v-if="curnum ==0 || curnum ==''"-->
                        <div class='goods_padd' style="margin-top: -8px;" v-if="curnum ==0 || curnum ==''">
                            <div class="mall-goods" v-for="(sub,index) in assorts"  style='min-height:inherit;'>
                                <div class="tit" >
                                    <div v-if="sub.isShow" >
                                        <b class='tit_div'>{{sub.Name}}</b>
                                    </div>
                                    <div class="maTop" v-if="sub.isShow">
                                        <div class="mall-goods-item"  @click="goto(item.Id)" v-for="(item,i) in sub.goods" :key="i" v-if="item.isShow == true ">
                                        <div class="goods-pic">
                                            <img :src="item.PicPaths.split(',')[0]"  alt="" />
                                        </div>
                                        <div class="goods-info">
                                            <div class="goods-money"><span>零售价</span>¥ {{item.Price}}</div>
                                            <div class="goods-txt">{{item.Name}}</div>
                                            <div class="goods-handle">
                                                <div class="goods-buy-btn">查看详情&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>  
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

import '../../../../html/components/crumbs/crumbs.scss';
import '../../../../html/components/crumbs/crumbs.css';
import '../../../../html/pages/mall/mall/mall.scss';
import {list,SystemCase,Advisory} from '../../../../api/index.js';
export default {
    name: 'mall',
    data() {
        return {
            detail: {},
            curnum:0,
            seen:0,
            current:1,
            banners:[],
            movable:'',
            assorts:[],
            typelist:[],
            inputSearch:'',
            keyId:1,
            StoreTypeId:1,
            show:false,
            hovernum:-1,
            search_input:'',
            moreList:[],

            tabIndex:-1,
            aaa:[1,2,3,4],
            aaaIndex:0,
            searchBarFixed:false,
            offsetTop:0,
            outerVisible:false,
            oInputId:false,
            phone: "",
            innerVisible: false,
            types:[],
            infotype:[],
            TypeIds:'',
            StoreSolution:[],
            StoreOther:[],
            indexs:-1,
            tabslist:[],
            allList:[]
            
        };
    },
    methods: {
        handleSelect(key, index) {
            var _this = this
            this.curnum=index;
            this.TypeIds = key.Id
            // var firstItem = _this.infotype.find(function(item){
            //     return item.TypeId == key.Id;
            // })
            this.tablist('',this.indexs)
            this.tabIndex=-1
        },
        tablist(key,index){

            var _this = this
            var c =[]
            
            this.tabIndex = index;
            if(index == -1 && key ==''){
                // this.StoreOther=[]
                // console.log(this.tabIndex)
            _this.tabslist = [];    
            this.infotype.forEach(function(item,index){
                if(_this.TypeIds == item.TypeId){
                    _this.tabslist.push(item.Id)
                }
            })
                _this.assorts.forEach(function(val,index,arr){
                    val.isShow = false;
                    val.goods.forEach(function(item,i,arr1){
                        item.isShow = false;
                        if(_this.tabslist.indexOf(item.StoreTypeId)>-1){
                            item.isShow = true;
                            val.isShow = true;
                        }
                    })
                })
                this.shop_good=[]
                _this.StoreOther.forEach(function (v, i) {
                    v.onShow =false;
                    c = _this.tabslist.filter(function(v1){ return v.StoreTypeIds.indexOf(v1) > -1 })
                    if (c.length>0) {
                        v.onShow = true;
                    }else{
                        v.onShow =false;
                    }
                });  
            
            // console.log(_this.tabslist)
            }else{
                
            // this.tabIndex = index;
            key.IsFirst = false
            
            // console.log(index)
            this.keyId = key.Id
            // this.StoreTypeId = key
            var _this = this
            _this.StoreOther.forEach(function (v, i) {
                if (v.StoreTypeIds.indexOf(_this.keyId) >= 0) {
                    v.onShow = true;
                }else{
                    v.onShow =false;
                }
            });
            _this.StoreSolution.forEach(function (v1, i1) {
                if (v1.StoreInfoTypeId.indexOf(_this.keyId) >= 0) {
                    v1.material.forEach(function (v2, i2) {
                        _this.StoreOther.forEach(function (v3, i3) {
                            if (v3.Id == v2.Id) {
                                v3.onShow = false;
                            }
                        });
                    });
                }
            });
            this.assorts.forEach(function(val,index,arr){
                val.isShow = false;
                val.goods.forEach(function(item,i,arr1){
                    item.isShow = false;
                    if(_this.keyId == item.StoreTypeId){
                        item.isShow = true;
                        val.isShow = true;
                    }
                })
            })
            }
            
        },
        moreSearch(){
           let routeData = this.$router.resolve({name: 'searchIndex',query: {type:1,id: this.keyId}});
            window.open(routeData.href, '_blank');
        },
        search(){
            let routeData = this.$router.resolve({ name: 'searchIndex', query: { type:2,searchStr: this.search_input}});
            window.open(routeData.href, '_blank');
            this.search_input=''
        },
        
        onMousteIn(index) {
            this.seen = 1;
            this.current = index;
        },
        onMousteOut(index) {
            this.seen != 1 ; //鼠标移出隐藏
            this.current = null;
        },
        goto(id) {
            let routeData = this.$router.resolve({ name: 'mallDetail', params: { id: id } });
            window.open(routeData.href, '_blank');
        },
        tel() {
            if (!/^1[345789]\d{9}$/.test(this.phone)) {
                // alert("请输入正确的手机号");
                this.oInputId = true;
                this.phone = "";
                return;
            }else{
               this.oInputId = false; 
            }
        },
        outer(){
            this.outerVisible = true;
            this.oInputId = false;
            this.phone = '';
        },
        async  open(id) {
            if(this.phone  || this.phone !=''){
                this.innerVisible=true;
                this.outerVisible = false;
                this.oInputId = false;
                let res = await Advisory({
                    id: id,
                    phone:this.phone
                });
            }else{
               this.oInputId = true; 
            }
            
        },
        async list(){
            var _this = this;
            let res = await list();
            if(res.Type == 'Success'){
                this.banners = res.Data.banner;
                this.types = res.Data.type;
                this.infotype = res.Data.infotype
                 

                this.StoreSolution = res.Data.StoreSolution
                this.StoreOther = res.Data.StoreOther

                this.movable = res.Data.movable;
                this.assorts = res.Data.list;
                this.typelist = res.Data.typelist;

                _this.TypeIds = _this.types[0].Id;
                this.tablist('',this.indexs)
            }else{
                this.$message.error(res.Content);
            }
        },
        async SystemCase(){
            let res = await SystemCase({
                typeId:''
            });
            if(res.Type == 'Success'){
                this.moreList = res.Data.goods
            }else{
                this.$message.error(res.Content);
            }
        },
        handleScroll () {
            if(this.offsetTop == 0){
                this.offsetTop = document.querySelector('#searchBar').offsetTop;
            }
            
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            scrollTop > 380 ? this.searchBarFixed = true : this.searchBarFixed = false
        },
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    },
    created() {
        this.list();
        this.SystemCase();
        var _this = this
        setTimeout(function(){
            window.addEventListener('scroll', _this.handleScroll)
        },50);
        
    }
}
</script>

<style>

.shop{cursor: pointer;}
.el-carousel ul{display:none;}
.imgSize{display:inline-block;width: 18px;}
.font_22{right: -5px;}
.menuImga{background-position: 18px 0px;}
.el-menu-item {
    padding: 0 22px!important;
}
.font16 .actives {
    background-color: #EEFFF8!important;
}
.item:hover .itemImg > div {
  bottom: 0 !important;
}
.item{position: relative;}
.el-tabs__content{display:none;}
.mall-goods{margin-left:0px;}
.el-carousel--horizontal {
    height: initial;
}
</style>
